import {SignUpResendToken} from 'domain/usecases';
import {RemoteSignUpResendToken} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {EntryFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeSignUpResendToken = (): SignUpResendToken =>
	new RemoteSignUpResendToken(
		makeBFFApiUrl(EntryFlowEndPoints.signUpResendToken),
		makeAuthorizeHttpClientDecorator(),
	);
